import {createSelector} from 'reselect';
import {AppState} from '../../index';
import {PollStatus} from '../../../shared/models/poll';
import {PollResponsePayload} from '../../../shared/models/api';

const filterMainPolls = (polls: PollResponsePayload[] | null): PollResponsePayload[] | null => {
  return polls?.filter((item) => item.statusId !== PollStatus.Completed && !item.isPassed).slice(0, 3) || null;
};

export const surveysListSelector = () =>
  createSelector(
    (state: AppState) => state.polls.list.surveys,
    (item) => item,
  );

export const votesListSelector = () =>
  createSelector(
    (state: AppState) => state.polls.list.votes,
    (item) => item,
  );

export const pollDetailsSelector = () =>
  createSelector(
    (state: AppState) => state.polls.details.poll,
    (item) => item,
  );

export const surveysMainListSelector = () =>
  createSelector(
    (state: AppState) => filterMainPolls(state.polls.list.surveys),
    (item) => item,
  );

export const votesMainListSelector = () =>
  createSelector(
    (state: AppState) => filterMainPolls(state.polls.list.votes),
    (item) => item,
  );
